export { default } from './HeartOutlineShadow'
